<template>
  <div class="initial">
    <h2>Welcome:</h2>
    <a target="__blank" href="https://getstarted.doulix.com/doulix-home/dna-synthesis-services/custom-gene-cloning/">
      <img src="https://pbs.twimg.com/media/EsAbDrIWMAYnQ_r?format=png&name=4096x4096" alt="Doulix meme">
    </a>
  </div>
</template>
<script>
export default {
  name: 'InitialDetailsPage'
}
</script>
<style scoped>

.card-header h2 {
  margin: 0.5em 1em 0.5em 1em;
}

.card-body > ul {
  margin: 0;
  padding: 1em;
}

.card-body > div {
  padding: 0 1em 0 1em;
}

.card-body > div h2 {
  font-size: 1.2em;
  font-weight: bold;
}

li, pre {
  width: 100%;
  overflow: auto;
  padding-top: 10px;
  word-break: break-word;
}

.initial {
  text-align: center;
}

.initial h2 {
  font-size: 20px;
  margin: 0.3em;
}

.initial img {
  max-width: 70%;
  max-height: 216px;
  margin: auto;
}
</style>